import React from "react"
import currencyRate from "../../../public/currency.json"

export const CurrConvertPrice = (price) => {

  let priceStr = ''
  let values = ['AED','EUR','USD']
  //get first currenct from env
  if(typeof process.env?.GATSBY_CurrencyConverter !== undefined){
    values = process.env.GATSBY_CurrencyConverter.split(',');
  }
  let currVal = values[0]
  
  //get localstorage value
  if (typeof window !== 'undefined') {
    if(localStorage.getItem('currTo') != null && localStorage.getItem('currTo') != currVal){
      // let calc
      return localStorage.getItem('currTo')+' '+parseInt(calcPrice(price,localStorage.getItem('currTo'),currVal)).toLocaleString()
    }
  }

  return currVal+' '+price;
}

function calcPrice(price,curr,defaultcurr) {
  //return 0
  return (currencyRate[curr] * ((currencyRate['GBP']/currencyRate[defaultcurr]) * parseInt(price.replaceAll(',', ''))) )
}